import { createContext, useContext, useState } from "react";

import { IAuthProviderData, IAuthProviderProps, IPatientData } from "./types";
import storage, { storagePrefix } from "../../utils/storage";

export const AuthContext = createContext<IAuthProviderData>(
  {} as IAuthProviderData
);

export const AuthProvider = ({ children }: IAuthProviderProps) => {
  const [patientData, setPatientData] = useState<IPatientData>(() => {

    const token = storage.getToken() || JSON.parse(sessionStorage.getItem(`${storagePrefix}token`) as string);
    const patientUser = JSON.parse(localStorage.getItem(`${storagePrefix}patientUser`) as string);

    if (token && patientUser) {
      return { token, patientUser };
    }

    return {} as IPatientData;
  });

  const logoutSession = () => {
    storage.clearToken();
    localStorage.clear();
    sessionStorage.clear();

    setPatientData({} as IPatientData);
  };

  return (
    <AuthContext.Provider
      value={{
        patientUser: patientData.patientUser,
        token: patientData.token,
        logoutSession,
        setPatientData,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
